import React, { useState } from "react";
import { convertThenFormat1 } from "../../common-data/Converts";
import { getGymStatus, getOverallStatus } from "../PayroleMocks";
import GymDetailsModal from "./GymDetailsModal";
import { ReloadIcon } from "../../../images/icons/icons";

const PPGymStatusSection = ({
  gymsData = [],
  userInfoData = {},
  callFunction,
  prevAllFilters
}) => {
  const iniModValues = {
    isModOpen: false,
    modName: "",
    rowData: "",
  };
  const [modValues, setModValues] = useState(iniModValues);

  const onCloseModal = () => {
    setModValues(iniModValues);
  };

  const overallStatus = getOverallStatus(gymsData);

  if (!gymsData || gymsData.length === 0) {
    return (
      <section className="pp-gym-status-section">
        <div className="pp-gym-status-header">
          <h2 className="pp-gym-status-title">Gym-wise Payroll Status</h2>
          <span className="pp-status-badge pp-status-badge--overall">
            No Data
          </span>
        </div>
        <div className="pp-gym-cards-grid">
          <div className="pp-no-data-message">
            No gym data available. Please check your filters or try again later.
          </div>
        </div>
      </section>
    );
  }

  return (
    <section className="pp-gym-status-section">
      <div className="pp-gym-status-header">
        <div className="pp-employee-payroll-card-header">
          <span>Gym-wise Payroll Status</span>
          <button variant="dark" type="button" onClick={callFunction}>
            <ReloadIcon />
          </button>
        </div>

        <span
          className={`pp-status-badge pp-status-badge--overall ${
            overallStatus === "Overdue" ? "pp-status-badge--overdue" : ""
          }`}
        >
          {overallStatus}
        </span>
      </div>

      <div className="pp-gym-cards-grid">
        {gymsData.map((gym) => (
          <div className="pp-gym-card" key={gym.gym_id}>
            <div className="pp-gym-card-header">
              <span className="pp-gym-name" title={gym.gym_name}>
                {gym.gym_name}
              </span>
              <span
                className={`pp-status-badge pp-status-badge--card ${
                  gym.issue_count > 0 || gym.pending_count > 0
                    ? "pp-status-badge--overdue"
                    : ""
                }`}
              >
                {getGymStatus(gym.issue_count, gym.pending_count)}
              </span>
            </div>
            <div className="pp-gym-label-value-row">
              <span className="pp-gym-label">Employees</span>
              <span className="pp-gym-value">{gym.employees_count}</span>
            </div>
            <div className="pp-gym-label-value-row">
              <span className="pp-gym-label">Total Payout</span>
              <span className="pp-gym-value pp-gym-value--payout">
                {`₹${convertThenFormat1(gym.total_payout)}`}
              </span>
            </div>
            <div className="pp-gym-progress-row">
              <span className="pp-gym-progress-text">
                {gym.processing_percent}% Processed
              </span>
              <div className="pp-gym-progress-bar">
                <div
                  className="pp-gym-progress-bar-fill"
                  style={{ width: `${gym.processing_percent}%` }}
                />
              </div>
            </div>
            <div className="pp-gym-status-counters">
              <div className="pp-gym-status-counter pp-gym-status-counter--processed">
                <div className="pp-gym-status-counter-number">
                  {gym.processed_count}
                </div>
                <div className="pp-gym-status-counter-label">Processed</div>
              </div>
              <div className="pp-gym-status-counter pp-gym-status-counter--pending">
                <div className="pp-gym-status-counter-number">
                  {gym.pending_count}
                </div>
                <div className="pp-gym-status-counter-label">Pending</div>
              </div>
              <div className="pp-gym-status-counter pp-gym-status-counter--issues">
                <div className="pp-gym-status-counter-number">
                  {gym.issue_count}
                </div>
                <div className="pp-gym-status-counter-label">Issues</div>
              </div>
            </div>
            <div className="pp-gym-card-footer">
              {/* <span className="pp-gym-deadline">
                <CalendarIcon color="#9ca3af" />
                <span>Deadline: {gym.payroll_deadline}</span>
              </span> */}
              <button
                className="pp-gym-details-btn"
                type="button"
                onClick={() =>
                  setModValues((prevs) => ({
                    ...prevs,
                    isModOpen: true,
                    modName: "view_details",
                    rowData: gym,
                  }))
                }
                aria-label={`View details for ${gym.gym_name}`}
              >
                View Details
              </button>
            </div>
          </div>
        ))}
      </div>

      {modValues.isModOpen && (
        <GymDetailsModal
          userInfoData={userInfoData}
          isOpen={modValues.isModOpen}
          onClose={onCloseModal}
          rowData={modValues.rowData}
          prevAllFilters={prevAllFilters}
        />
      )}
    </section>
  );
};

export default PPGymStatusSection;
